<template>
  <v-container fluid>
    <BrAppBar>
      <div class="py-3 title d-none d-sm-block">
        {{ $t('pixel.title') }}
      </div>
    </BrAppBar>

    <div class="title d-sm-none">
      {{ $t('pixel.title') }}
    </div>
    
    <v-row class="py-3">
      <v-col class="flex-column" style="display: flex;gap: 25px;" cols="12">
        <v-card
          elevation="5"
          outlined
        >
          <v-col md="6">
            <v-card-text>
              <v-skeleton-loader
                :loading="loading"
                :transition="'fade-transition'"
                type="heading"
                width="160"
                height="30"
              >
                <v-text-field 
                  v-model="items.idPixel"
                  outlined
                  :label="$t('pixel.facebookPixelId')"
                  single-line
                  class="flex-column input"
                >
                <template v-slot:prepend>
                  <span class="label mb-2 pl-2">{{ $t('pixel.facebookPixelId') }}:</span>
                </template>
                </v-text-field>
              </v-skeleton-loader>


              <v-btn
                @click="submit()"
                :color="variables.colorSuccess"
                :loading="loadingBtn"
                class="mt-5 btn-saque"
                rounded-lg
                dark
              >
                {{ $t('common.save') }}
              </v-btn>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import { mapActions, mapGetters } from 'vuex'
// import listagemTables from '@/views/mixins/listagemTables'
import moment from 'moment'
import variables from '@/assets/styles/helpers/_variables.scss'
// import Events from '@/core/service/events'
// import Baseconfig from '@/core/config'


export default {
  name: 'Carteira',
  // mixins: [listagemTables],
  components: {
    BrAppBar: () => import('@/views/layout/appBar'),
  },
  data: () => ({
    loading: false,
    loadingTable: false,
    loadingBtn: false,
    value: 0.0,
    typeKeyCode: 'CPF',
    keyCode: null,
    rangeDate: {
      start: moment().subtract(7, 'd').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    headersData: [
      // { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      // { align: 'start', class: 'table-header', text: 'Método', value: 'method' },
      { align: 'start', class: 'table-header', text: 'Data', value: 'created' },
      { align: 'start', class: 'table-header', text: 'Valor', value: 'value' },
      { align: 'start', class: 'table-header', text: 'Status', value: 'status' },
    ]
  }),
  computed: {
    ...mapGetters('pixel', ['items']),
    ...mapGetters('auth', ['user']),

    variables: () => variables,

    
  },
  mounted() {
    this.loadingBtn = true
    this.getItens()
      .catch((e) => errorSnackbar(e.error))
      .finally(() => {
        this.loadingBtn = false
      })

  },
  methods: {
    ...mapActions('pixel', ['getItens', 'salvar']),

    submit () {
      this.loadingBtn = true
      this.salvar({ pixels: this.items })
         .then(() => {
           successSnackbar(this.$t('pixel.idsSalvos'))
        })
        .catch((e) => errorSnackbar(e.error))
        .finally(() => {
          this.loadingBtn = false
        })
  }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/components/table';


.title {
  color: #FFFFFF !important;
}


.theme--light.v-card {
  background: #1D1D29 !important;
  border-radius: 16px;
}

.card-table {
  background: #1D1D29;
  border-radius: 16px;
}

.label {
  color: #FFF;
}

.input::v-deep input {
  color: #FFF;
}

.v-text-field--outlined::v-deep fieldset {
  border-color: #373749;
}
</style>
